module.exports = __webpack_public_path__ + "img/95204ac.svg";